<template>
  <div class="card mb-3">
    <div class="card-header">
      <i class="fa fa-briefcase"></i> {{ $t('role.title') }}
      <createButton name="roles_create" :title="$t('role.create.title')"></createButton>
    </div>
    <div class="card-body">
      
      <errorMessage v-bind:message="error"></errorMessage>

      <div class="table-responsive">
        <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0">
          <thead>
            <tr>
              <th>{{ $t('role.form.name') }}</th>
              <th>{{ $t('role.form.displayName') }}</th>
              <th class="no-sort no-filter" width=200 v-if="canCreate || canDelete">&nbsp;</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th>{{ $t('role.form.name') }}</th>
              <th>{{ $t('role.form.displayName') }}</th>
              <th class="no-sort no-filter" width=200 v-if="canCreate || canDelete">&nbsp;</th>
            </tr>
          </tfoot>
          <tbody>
            <tr v-for="entity in entites" :key="entity.id" v-bind:data-id="entity.id" @click="view(entity.id)" class="clickable-row">
              <td>{{entity.name}}</td>
              <td>{{entity.displayName}}</td>
             
              <td class="no-sort" align="center" v-if="canCreate || canDelete">
                <div v-if="entity.name != 'Admin' && entity.isStatic != 1">
                  <a href="#" v-if="canCreate" v-bind:title="$t('form.edit_button')" v-on:click.stop="edit(entity.id)">
                    <span class="fa fa-lg fa-pencil"></span>
                  </a>
                  &nbsp;
                  <a  href="#" v-if="canCreate" v-bind:title="$t('form.copy_button')" v-on:click.stop="copy(entity.id)">
                    <span class="fa fa-lg fa-copy"></span>
                  </a>
                  &nbsp;
                  <a class="text-danger" v-if="canDelete" v-bind:title="$t('form.delete_button')" href="#" v-on:click.stop="deleteEntity(entity.id)">
                    <span class="fa fa-lg fa-trash"></span>
                  </a>
                </div>
                <div v-if="entity.name == 'Admin' || entity.isStatic == 1">
                  <span class="fa fa-lg fa-pencil text-muted"></span>
                  &nbsp;
                  <span class="fa fa-lg fa-copy text-muted"></span>
                  &nbsp;
                  <span class="fa fa-lg fa-trash text-muted"></span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {RoleServiceClient} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import SearchMixin from '../../shared/Mixin/SearchMixin'

export default {
  name: 'Roles',
  mixins: [SearchMixin],
  data() {
    return {
      serviceClient: RoleServiceClient,
    }
  },
  methods: {
    fetchData: function() {
      let service = ServiceFactory.create(this.serviceClient)
      let self = this

      service
        .getAll(0, 10000)
        .then(res => {
          self.entites = res.items
          self.showDataTable()
        })
        .catch(err => {
          self.error = self.getErrorMessage(err)
        })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>




// WEBPACK FOOTER //
// src/components/roles/Roles.vue